import classnames from 'classnames';
import React from 'react';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import classes from './production-time-tooltip.scss';
const productionTimeTooltipStyles = {
  popper: classes.productionTimeTooltipPopper,
  tooltip: classes.tooltipRoot
};
export const ProductionTimeTooltip = ({
  infoWrapperClassName = '',
  infoItemColor = '',
  placement = Placement.RIGHT,
  isEmbroideryEmbellishmentMethod = false
}) => {
  const tooltipText = isMobile() ? '' : 'You will receive a production mockup within 2-3 business days after your colors are approved. The time to create the production mockup is already reflected in your estimated delivery date. After you approve your production mockup, we will start making your items!';
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText,
    placement: placement,
    mode: "light",
    className: infoWrapperClassName,
    classes: productionTimeTooltipStyles
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    iconColor: infoItemColor,
    className: classnames(classes.infoButton),
    "aria-label": "Production time info"
  }));
};